
<div class="w-100 pr-1" >
    <v-progress-linear
        v-if = "loading"
        indeterminate
        color="primary"
        height="4"
    />
    <div v-if="showFilter" class="lm-border pa-3 mb-2">
        <v-row class="no-frame " >
            <v-col class="no-frame unit-search-input col-12">
                <v-text-field
                    v-model = "search"
                    @input  = "onSearch"
                    :height="32"
                    hide-details
                    clearable
                    dense
                    mt-0 pt-0
                />
            </v-col>
        </v-row>
        <v-row class="no-frame " >
            <v-col class="no-frame v-flex">
                <v-checkbox
                    label   = "nur aktive Anlagen"
                    class   = "mt-0"
                    :ripple = "false"
                    hide-details
                />
            </v-col>
        </v-row>
    </div>


    <v-row class="no-frame" style="max-height: 500px; overflow-y: scroll; overflow-x: hidden" v-if="filteredUnits && !loading">
        <v-col class="no-frame col-12 pr-1">
            <div v-for="(unit, index) in filteredUnits" :key="index" class="mb-2">
                <p-dms-treeview-unit-entry
                    :unit     = "unit"
                    @site     = "onSite"
                    @selected = "onSelected"
                />
            </div>
        </v-col>
    </v-row>
</div>
